import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["textContent"]

import { toRefs } from 'vue';

interface DisciplineIconInterface {
  code: string;
  name: string;
}

interface Props {
  icon?: DisciplineIconInterface;
  className?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ClinicianDisciplineIcon',
  props: {
    icon: {},
    className: {}
  },
  setup(__props: any) {

const props = __props;
const { icon, className } = toRefs(props);

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(className))
  }, [
    _createVNode(_component_Icon, {
      name: _unref(icon)?.name || 'category',
      size: "text-base",
      class: "mr-1 text-color-purple"
    }, null, 8, ["name"]),
    _createElementVNode("span", {
      class: "text-sm",
      textContent: _toDisplayString(_unref(icon)?.code)
    }, null, 8, _hoisted_1)
  ], 2))
}
}

})